import apiClient from '@/config/api';

const RESOURCE = '/carousel';
const cfg = () => ({
    headers: { 'Content-Type': 'multipart/form-data' }
});

export default {
    async getCarousel({ commit }) {
        const response = await apiClient.get(RESOURCE);
        const items = response.data.data || [];
        commit('SET_ITEMS', items);
        return items;
    },

    async getPlacements() {
        const response = await apiClient.get(`${RESOURCE}/placements`);
        return response.data.data || [];
    },

    async createCarousel({ commit }, formData) {
        const response = await apiClient.post(`${RESOURCE}/campaigns`, formData, cfg());
        commit('ADD_ITEM', response.data.data);
        return response.data;
    },

    async updateCarousel({ commit }, { id, formData }) {
        const response = await apiClient.post(`${RESOURCE}/campaigns/${encodeURIComponent(id)}`, formData, cfg());
        commit('UPDATE_ITEM', response.data.data);
        return response.data;
    },

    async deleteCarousel({ commit }, id) {
        const response = await apiClient.delete(`${RESOURCE}/campaigns/${encodeURIComponent(id)}`);
        commit('REMOVE_ITEM', id);
        return response.data;
    },
}
